<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="ការកក់ទាំងអស់" name="first"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>ស្វែងរកតាមរយៈ លេខកូដ លេខទូរស័ព្ទ អ្នកផ្ញើ ឬ អ្នកទទួល</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-70 md-size-20">
					<md-field>
						<label>ស្ថានភាព</label>
						<md-select placeholder="ស្ថានភាព (ទាំងអស់)" v-model="search.status">
							<md-option value="">ទាំងអស់</md-option>
							<md-option value="NODRIVER">មិនមានអ្នកទៅយក</md-option>
							<md-option value="PENDING">កំពុងទៅទទួលយក</md-option>
							<md-option value="COMPLETED">បានទៅទទួល</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-30 md-size-20">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">ស្វែងរក</md-button>
				</div>
			</div>
			<md-table v-if="bookList.length > 0">
				<md-table-row>
					<md-table-head>លេខកូដ និងកាលបរិច្ឆេទ</md-table-head>
					<md-table-head>អ្នកដាក់ស្នើ</md-table-head>
					<md-table-head>អ្នកទៅទទួល</md-table-head>
					<md-table-head>ថ្ងៃទៅទទួល និងចំនួន</md-table-head>
					<md-table-head>ចំណាំរបស់អ្នកស្នើ</md-table-head>
					<md-table-head>ស្ថានភាព</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(pkg, index) in bookList">
					<md-table-cell>​{{ index + 1 }}, <b>{{ pkg.code }}</b><br>{{config.datelify(pkg.created_date)}}
					</md-table-cell>
					<md-table-cell><b>{{pkg.client_name}}</b></md-table-cell>
					<md-table-cell>
						<span v-if="pkg.driver_name == null">មិនមានអ្នកទទួល</span>
						<span v-else><b>{{ pkg.driver_name }}</b><br>{{ pkg.driver_phone }}</span>
					</md-table-cell>
					<md-table-cell><b>{{ pkg.pickup_date }}</b><br>{{pkg.total_package}} កញ្ចប់</md-table-cell>
					<md-table-cell>{{pkg.description}}</md-table-cell>
					<md-table-cell>
						<span class="error" v-if="pkg.status == 'NODRIVER'">{{ config.getStatus(pkg.status) }}</span>
						<span class="neutral" v-if="pkg.status == 'PENDING'">{{ config.getStatus(pkg.status) }}</span>
						<span class="green" v-if="pkg.status == 'COMPLETED'">{{ config.getStatus(pkg.status) }}</span>
						<span class="return" v-if="pkg.status == 'CANCELED'">{{ config.getStatus(pkg.status) }}</span>
					</md-table-cell>
					<md-table-cell>
						<router-link :to="'/booking/detail/' + pkg.hash_id">
							<md-button class="md-just-icon md-simple md-primary">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">មើលលម្អិត</md-tooltip>
							</md-button>
						</router-link>
						<template v-if="allow_user('sa|da')">
							<md-button class="md-just-icon md-simple md-danger" @click="showCancelAction(pkg.hash_id)" v-if="pkg.status != 'COMPLETED' && pkg.status != 'CANCELED'">
								<md-icon>cancel</md-icon>
								<md-tooltip md-direction="top">បោះបង់</md-tooltip>
							</md-button>
						</template>
						<template v-if="allow_user('sa|da')">
							<md-button class="md-just-icon md-simple md-danger" @click="showDeleteAction(pkg.hash_id)">
								<md-icon>delete_forever</md-icon>
								<md-tooltip md-direction="top">លុបចោល</md-tooltip>
							</md-button>
						</template>
					</md-table-cell>

				</md-table-row>
			</md-table>
			<h4 class="text-center" v-if="bookList.length == 0 && loadMore == true">មិនមានកញ្ចប់ឥវ៉ាន់</h4>
			<div class="places-buttons text-center" v-if="loadMore">
				<md-button class="md-primary" @click="searchHandler(true)">បង្ហាញបន្ថែម</md-button>
			</div>
		</div>


		<md-dialog-confirm :md-active.sync="cancelDialogActive" md-title="តើអ្នកពិតជាចង់បោះបង់ការកក់នេះពិតមែនទេ ?" md-confirm-text="យល់ព្រម"
			md-cancel-text="បោះបង់" @md-cancel="onCancel" @md-confirm="cancel" />
		<md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុបការកក់នេះពិតមែនទេ ?" md-confirm-text="យល់ព្រម"
			md-cancel-text="បោះបង់" @md-cancel="onCancel" @md-confirm="delete_book" />
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				cancelDialogActive: false,
				cancelSelected: '',
				deleteDialogActive: false,
				deleteSelected: '',
				search: {
					text: "",
					status: "PENDING"
				},
				loadMore: false,
				bookList: []
			}
		},
		methods: {
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/book/search", {
					text: this.search.text,
					status: this.search.status,
					offset: more ? this.bookList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.bookList = more ? this.bookList.concat(data.body.data) : data.body.data;
				})

			},
			showCancelAction(id) {
				this.cancelSelected = id
				this.cancelDialogActive = true
			},
			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			cancel() {
				this.$http.post(this.config.api + "/admin/book/cancel", {
					hash_id: this.cancelSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "ការកក់ត្រូវបានបោះបង់ដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			delete_book() {
				this.$http.post(this.config.api + "/admin/book/delete", {
					hash_id: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "ការកក់ត្រូវបានលុបដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.cancelSelected = ""
				this.cancelDialogActive = false
				this.deleteSelected = ""
				this.deleteDialogActive = false
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Booking/View.vue